import Vue from 'vue'

const getDefaultState = () => {
  return {
    error: null,
    response: null,
    headerError: {
      message: '',
      urlName: '',
      urlLabel: '',
      closable: true
    }
  }
}

const state = getDefaultState()

const actions = {
  setError (context, error) {
    // It's only in the case of an unconfirmed user that we don't logout
    if (error.response.status === 403 && error.response.data.error !== 'unconfirmed.user') {
      context.dispatch('auth/logOut', null, { root: true })
    } else {
      context.commit('setError', error)
    }
  },

  setHeaderError (context, error) {
    context.commit('setHeaderError', error)
  },

  removeHeaderError (context) {
    context.commit('removeHeaderError')
  },

  resetState (context) {
    context.commit('resetState')
  }
}

const mutations = {
  setError (state, error) {
    state.response = error && error.response
    state.error = error
  },

  setHeaderError (state, error) {
    if (error.closable === undefined) {
      error.closable = true
    }
    state.headerError = error
  },

  removeHeaderError (state) {
    Vue.set(state, 'headerError', {})
  },

  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  hasHeaderError: state => {
    return Boolean(state.headerError.message && state.headerError.message.length)
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
